module.exports = __webpack_public_path__ + "static/media/bgNature.5ab59ad8.png";